/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Flex, Tooltip } from "@nordcloud/gnui";
import { MultiSelectButton } from "../Styled/MultiSelectButton";
import { FiltersProp, Provider } from "./types";

type Props = {
  value: Provider[];
  filters: FiltersProp;
  setFilters: (filter: FiltersProp) => void;
};

export function ProviderMultiSelect({ value, filters, setFilters }: Props) {
  const toggleProvider = (provider: Provider) => {
    if (
      filters.provider?.find(
        (filterProvider: Provider) => filterProvider === provider
      )
    ) {
      setFilters({
        ...filters,
        provider: filters.provider?.filter(
          (filterProvider: Provider) => filterProvider !== provider
        ),
      });
    } else {
      setFilters({
        ...filters,
        provider: [...(filters.provider ?? []), provider],
      });
    }
  };

  return (
    <Flex justifyContent="flex-start">
      <Tooltip caption="AWS">
        <MultiSelectButton
          icon="aws"
          value={value?.find((provider) => provider === Provider.AWS)}
          severity="medium"
          onClick={() => toggleProvider(Provider.AWS)}
          aria-label="aws-icon"
        />
      </Tooltip>
      <Tooltip caption="GCP">
        <MultiSelectButton
          icon="gcp"
          value={value?.find((provider) => provider === Provider.GCP)}
          severity="medium"
          onClick={() => toggleProvider(Provider.GCP)}
          aria-label="gcp-icon"
        />
      </Tooltip>
      <Tooltip caption="AZURE">
        <MultiSelectButton
          icon="azure"
          value={value?.find((provider) => provider === Provider.AZURE)}
          severity="medium"
          onClick={() => toggleProvider(Provider.AZURE)}
          aria-label="azure-icon"
        />
      </Tooltip>
      <Tooltip caption="ALIBABA">
        <MultiSelectButton
          icon="alibaba"
          value={value?.find((provider) => provider === Provider.ALIBABA)}
          severity="medium"
          onClick={() => toggleProvider(Provider.ALIBABA)}
          aria-label="alibaba-icon"
        />
      </Tooltip>
      <Tooltip caption="IBM CLOUD">
        <MultiSelectButton
          icon="ibmCloud"
          value={value?.find((provider) => provider === Provider.IBM_CLOUD)}
          severity="medium"
          onClick={() => toggleProvider(Provider.IBM_CLOUD)}
          aria-label="ibm-cloud-icon"
        />
      </Tooltip>
      <Tooltip caption="ON PREMISE">
        <MultiSelectButton
          icon="hybridCloud"
          value={value?.find((provider) => provider === Provider.ON_PREMISE)}
          severity="medium"
          onClick={() => toggleProvider(Provider.ON_PREMISE)}
          aria-label="on-premise-icon"
        />
      </Tooltip>
    </Flex>
  );
}
